if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        const menueSchublade = document.querySelector('.menu-drawer');
        if (menueSchublade) menueSchublade.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();

        /*
         * Absicherung gegen unbeabsichtigtes Umschalten.
         *
         * Die Eintraege der Sprach- und Laenderliste stehen dauerhaft im
         * Dokument; sichtbar werden sie nur, wenn das Auswahlfeld geoeffnet
         * ist. Trifft ein Klick sie, waehrend die Liste zu ist - etwa ein
         * nachlaufender Tipper auf dem Handy, ein uebernommener Klick aus einem
         * darueberliegenden Element oder ein ausgeloester Klick aus fremdem
         * Code -, wurde bisher trotzdem das Formular abgeschickt und die
         * Sprache dauerhaft umgestellt. Genau das darf nicht passieren.
         *
         * Umgeschaltet wird deshalb nur noch, wenn die Liste wirklich offen
         * ist und der angeklickte Eintrag einen gueltigen Wert traegt.
         */
        const auswahlOffen =
          this.elements.button && this.elements.button.getAttribute('aria-expanded') === 'true';
        const wert = event.currentTarget && event.currentTarget.dataset
          ? event.currentTarget.dataset.value
          : null;

        if (!auswahlOffen || !wert || !this.elements.input) return;

        // Bewusste Wahl merken, damit die Sprachsicherung sie nicht zurueckdreht.
        try {
          document.cookie =
            'lx_sprachwahl=' + encodeURIComponent(wert) + '; path=/; max-age=31536000; samesite=lax';
        } catch (e) {}

        const form = this.querySelector('form');
        this.elements.input.value = wert;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }
        const menueSchubladeAuf = document.querySelector('.menu-drawer');
        if (menueSchubladeAuf) menueSchubladeAuf.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

/*
 * ---------------------------------------------------------------------------
 * Sprachsicherung
 * ---------------------------------------------------------------------------
 *
 * Deutsch ist die Hauptsprache und liegt auf der Wurzel-Adresse. Englisch und
 * Franzoesisch liegen unter /en und /fr.
 *
 * Diese Sicherung holt Besucher auf die deutsche Fassung zurueck, wenn sie
 * ohne eigenes Zutun auf einer fremdsprachigen Adresse gelandet sind.
 *
 * Zurueckgeholt wird in zwei Faellen:
 *   1. Der Browser des Besuchers ist auf Deutsch eingestellt. Ein deutscher
 *      Kunde soll den Shop nie auf Englisch sehen, ausser er will es selbst.
 *   2. Der Besucher kam von der deutschen Fassung dieser Seite und steht
 *      ploetzlich auf einer fremdsprachigen Adresse.
 *
 * Unangetastet bleiben:
 *   - jeder, der selbst eine Sprache gewaehlt hat (Merker lx_sprachwahl),
 *   - auslaendische Besucher mit fremdsprachigem Browser, die von aussen
 *     kommen - ueber Suchmaschine, eBay, Werbung, Lesezeichen oder direkt,
 *   - Suchmaschinen, damit die englischen und franzoesischen Seiten weiter
 *     gefunden werden.
 *
 * Hoechstens zwei Korrekturen je Sitzung, und dieselbe Adresse nie zweimal.
 * Damit kann keine Schleife entstehen.
 */
(function () {
  var FREMDSPRACHEN = ['en', 'fr', 'it', 'es', 'nl'];
  var HAUPTSPRACHE = 'de';

  function istDeutscherBrowser() {
    var liste = [];
    try {
      if (navigator.languages && navigator.languages.length) {
        liste = Array.prototype.slice.call(navigator.languages);
      } else if (navigator.language) {
        liste = [navigator.language];
      }
    } catch (e) {
      return false;
    }
    for (var i = 0; i < liste.length; i++) {
      var code = String(liste[i] || '').toLowerCase().split('-')[0];
      if (code === HAUPTSPRACHE) return true;
      // Eine vorangestellte Fremdsprache zaehlt staerker als ein spaeteres de.
      if (FREMDSPRACHEN.indexOf(code) > -1) return false;
    }
    return false;
  }

  function kamVonDeutscherFassung() {
    var verweis = document.referrer || '';
    if (!verweis) return false;
    var quelle;
    try {
      quelle = new URL(verweis);
    } catch (e) {
      return false;
    }
    if (quelle.host !== window.location.host) return false;
    var quellVorsatz = (quelle.pathname.split('/')[1] || '').toLowerCase();
    return FREMDSPRACHEN.indexOf(quellVorsatz) === -1;
  }

  try {
    // Welche Sprache liefert der Server gerade aus? Steht im html-Element.
    var aktuell = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    if (!aktuell || aktuell === HAUPTSPRACHE) return;
    if (FREMDSPRACHEN.indexOf(aktuell) === -1) return;

    // Liegt die Sprache wirklich als Vorsatz im Pfad? Sonst nichts anfassen.
    var teile = window.location.pathname.split('/');
    if ((teile[1] || '').toLowerCase() !== aktuell) return;

    // Wurde die Sprache bewusst gewaehlt?
    if (document.cookie.indexOf('lx_sprachwahl=') > -1) return;

    if (!istDeutscherBrowser() && !kamVonDeutscherFassung()) return;

    // Schleifenschutz.
    var merker = window.sessionStorage.getItem('lx_sprachkorrektur') || '';
    var bereits = merker ? merker.split('|') : [];
    if (bereits.length >= 2) return;
    if (bereits.indexOf(window.location.pathname) > -1) return;
    bereits.push(window.location.pathname);
    window.sessionStorage.setItem('lx_sprachkorrektur', bereits.join('|'));

    teile.splice(1, 1);
    var ziel = teile.join('/') || '/';
    window.location.replace(ziel + window.location.search + window.location.hash);
  } catch (e) {
    // Die Sicherung ist Beiwerk. Faellt sie aus, bleibt die Seite wie sie ist.
  }
})();
